module.exports = __webpack_public_path__ + "static/media/surveying_row.4de3eb7b.jpg";